<template>
    <div class='container'>
        <div class="content">
            <div class="title_box">
                <div class="left"></div>
                <div class="title">体验结果反馈</div>
            </div>
            <div class="input_box">
                <div class="info">
                    <div class="tip flc"><span class="mustFill">*</span>邀约签单手：</div>
                    <div class="input2">
                        {{options.sign_name}}
                    </div>
<!--                    <input type="text" placeholder="请输入签单手名称" v-model="options.sign_name">-->
                </div>
                <div class="info">
                    <!-- <div class="info" @click="BselectTime = true"> -->
                    <div class="tip flc">预约时间：</div>
                    <div class="input2">
                        {{appointTime(options.appoint_time)}}
                    </div>
                </div>

                <div class="info">
                    <div class="tip flc">打卡时间：</div>
                    <div class="input2">
                        {{options.sign_at}}
                    </div>
                </div>
                <div class="info" @click="showExperienceTime">
                    <!-- <div class="info" @click="BselectTime = true"> -->
                    <div class="tip flc"><span class="mustFill">*</span> 体验时长：</div>
                    <div class="input2" :class="{'colorGray':!selectExperience}">{{selectExperience ? selectExperience + '小时' : '请选择体验时长'}}</div>
                </div>
                <div class="info" @click="selectType">
                    <!-- <div class="info" @click="BselectTime = true"> -->
                    <div class="tip flc"><span class="mustFill">*</span>客户类型：</div>
                    <div class="input2" :class="{'colorGray':!userTypeObj.name}">{{userTypeObj.name || '请选择客户类型'}}</div>
                </div>

                <div class="info">
                    <!-- <div class="info" @click="BselectTime = true"> -->
                    <div class="tip flc">客户昵称：</div>
                    <div class="input2">{{options.nickname || ''}}</div>
                </div>

<!--                <div class="info">-->
<!--                    <div class="tip flc"><span class="mustFill">*</span>客户电话：</div>-->
<!--                    &lt;!&ndash; <input ref="phoneInputRef" type="number" placeholder=""  v-model="options.phone" @blur="testPhone"> &ndash;&gt;-->
<!--                    <div class="input2">{{options.phone}}</div>-->
<!--                </div>-->
                <div class="href">
                    <div class="item">
                        <div class="tip flc"><span class="mustFill">*</span>客户姓名：</div>
                        <input type="text" v-model="options.uname" :disabled="$route.query.user_type == 0 ||$route.query.user_type == 1">
                    </div>
                    <div class="item">
<!--                        <div class="tip flc"><span class="mustFill">*</span>信息渠道：</div>-->
<!--                            <input type="text" placeholder="" disabled  v-model="options.account_source">-->
                        <div class="tip flc">性别：</div>
                        <div class="flc2">{{options.sex == 1 ? '男': options.sex == 2 ? '女' : '未知'}}</div>
                    </div>
                </div>


                <div class="info">
                    <div class="tip flc">客户电话：</div>
                     <input ref="phoneInputRef" :disabled="$route.query.user_type == 0" maxlength="11" type="number" placeholder="请输入客户电话"  v-model="options.phone">
<!--                    <div class="input2">{{options.phone}}</div>-->
                </div>
                <div class="info" @click="selectSource" v-if="$route.query.user_type != 1 && $route.query.user_type != 2 && $route.query.user_type != 5">
                    <div class="tip flc"><span class="mustFill">*</span>信息渠道：</div>
                    <!-- <input ref="phoneInputRef" type="number" placeholder="" dddddd v-model="options.phone" @blur="testPhone"> -->
                    <div class="input2">{{options.account_source}}</div>
                </div>

                <div class="info"  v-if="$route.query.user_type != 1 && $route.query.user_type != 2 && $route.query.user_type != 5">
                    <div class="tip flc">安装小区：</div>
                    <div class="inputbox flc2">
                        <div class="input">{{options.community || '默认'}}</div>
                        <!-- <input type="text" placeholder="" v-model="options.community"> -->
                        <textarea placeholder="请填写小区" v-model="options.community" maxlength="140"></textarea>
                    </div>
                </div>
<!--                <div class="href">-->
<!--                    <div class="item">-->
<!--                        <div class="tip flc">客户年龄：</div>-->
<!--                            <input type="number" placeholder="请填写年龄" v-model="options.age" @input="ageChange">-->
<!--                    </div>-->
<!--                    <div class="item">-->
<!--                        <div class="tip flc">职业：</div>-->
<!--                            <input ref="jobInputRef" type="text" placeholder="请输入职业" v-model="options.job" @blur="jobChange">-->
<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="line">
                <img src="@/assets/images/user/talk/border-bottom.png" alt="">
            </div>
            <div class="silder_group">
                <div class="silder_item">
                    <div class="tip flc"><span style="color:red;">*</span>是否设计师带看：</div>
                    <div class="silder">
                        <div class="flc" @click="silderClick('is_design',1)" :class="{'silder_active':options.is_design != 0}">是</div>
                        <div class="flc" @click="silderClick('is_design',0)" :class="{'silder_active':options.is_design == 0}">否</div>
                    </div>
                </div>
                <div class="silder_item">
                    <div class="tip flc">史密斯负责人是否在场：</div>
                    <div class="silder">
                        <div class="flc" @click="silderClick('sign_state',1)" :class="{'silder_active':options.sign_state != 0}">是</div>
                        <div class="flc" @click="silderClick('sign_state',0)" :class="{'silder_active':options.sign_state == 0}">否</div>
                    </div>
                </div>
                <div class="silder_item">
                    <div class="tip flc">专职人员是否在场：</div>
                    <div class="silder">
                        <div class="flc" @click="silderClick('prospect_state',1)" :class="{'silder_active':options.prospect_state != 0}">是</div>
                        <div class="flc" @click="silderClick('prospect_state',0)" :class="{'silder_active':options.prospect_state == 0}">否</div>
                    </div>
                </div>
                <div class="silder_item">
                    <div class="tip flc">前期是否去过门店：</div>
                    <div class="silder">
                        <div class="flc" @click="silderClick('is_store',1)" :class="{'silder_active':options.is_store != 0}">是</div>
                        <div class="flc" @click="silderClick('is_store',0)" :class="{'silder_active':options.is_store == 0}">否</div>
                    </div>
                </div>
            </div>
            <div class="select_group" v-if="feed_type.length != 0">
                <div class="select_item">
                    <div class="tip flc"><span style="color:red;">*</span>带看属于第几次交流：</div>
                    <div class="select" @click="selectNum('select_num')">
                        <div>{{Number(options.num_chat)?options.num_chat + '次':'请选择'}}</div>
                        <div class="img_box">
                            <img src="@/assets/images/user/prospect/chevron-down.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="select_item">
                    <div class="tip flc"><span style="color:red;">*</span>体验人数：</div>
                    <div class="select" @click="selectNum('people_num')">
                        <div>{{Number(options.user_num)?options.user_num + '人':'请选择'}}</div>
                        <div class="img_box">
                            <img src="@/assets/images/user/prospect/chevron-down.png" alt="">
                        </div>
                    </div>
                </div>

                <div class="select_item" v-if="showResult">
                    <div class="tip flc"><span style="color:red;">*</span>{{feed_type[0].name}}</div>
                    <div class="select" @click="selectfeedType(0)">
                        <div>{{showfeedType(0)}}</div>
                        <div class="img_box">
                            <img src="@/assets/images/user/prospect/chevron-down.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="select_item" v-if="showResult">
                    <div class="tip flc"><span style="color:red;">*</span>{{feed_type[1].name}}</div>
                    <div class="select" @click="selectfeedType(1)">
                        <div>{{showfeedType(1)}}</div>
                        <div class="img_box">
                            <img src="@/assets/images/user/prospect/chevron-down.png" alt="">
                        </div>
                    </div>
                </div>
<!--                <div class="select_item">-->
<!--                    <div class="tip flc">带看结果：</div>-->
<!--                    <div class="select">-->
<!--                        <div>数量</div>-->
<!--                        <div class="img_box">-->
<!--                            <img src="@/assets/images/user/prospect/chevron-down.png" alt="">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="select_item">-->
<!--                    <div class="tip flc">对比系统：</div>-->
<!--                    <div class="select">-->
<!--                        <div>数量</div>-->
<!--                        <div class="img_box">-->
<!--                            <img src="@/assets/images/user/prospect/chevron-down.png" alt="">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div> -->
            </div>
<!--            <div class="input_box">-->
<!--                <div class="info">-->
<!--                    <div class="tip flc">带看结果：</div>-->
<!--                    <div class="inputbox flc2">-->
<!--                        <div class="input">{{options.community || '默认'}}</div>-->
<!--                        &lt;!&ndash; <input type="text" placeholder="" v-model="options.community"> &ndash;&gt;-->
<!--                        <textarea placeholder="请填写带看结果" v-model="options.reason_chat" maxlength="140"></textarea>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="input_group">
                <div class="textarea_box"  v-if="!showResult">
                    <div class="tip">带看结果：</div>
                    <div class="textarea">
                        <div>{{options.reason_chat || '一个'}}</div>
                        <input type="text" v-model="options.reason_chat">
                    </div>
                </div>
                <div class="textarea_box">
                    <div class="tip">其他在场人员：</div>
                    <div class="textarea">
                        <div>{{options.prospect_name||'一个'}}</div>
                        <textarea v-model="options.prospect_name" maxlength="140"></textarea>
                    </div>
                </div>
                <div class="textarea_box" v-if="Breason == 'successReason'">
                    <div class="tip"><span class="mustFill">*</span>成单原因：</div>
                    <div class="textarea">
                        <div>{{options.reason_success||'一个'}}</div>
                        <textarea maxlength="140" v-model="options.reason_success" placeholder=""></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn flc" @click="submit">提交</div>

        <!-- 时间选择器 -->
        <van-popup v-model="BselectTime" round position="bottom">
            <van-datetime-picker
                type="date"
                @confirm="selectTime"
                title="选择年月日"
            />
        </van-popup>

        <!-- picker选择器 -->
        <van-popup v-model="BselectInfo" round position="bottom">
            <van-picker
                title="请选择"
                show-toolbar
                :columns="columns"
                :value-key="pickerKey"
                @confirm="selectInfo"
                @cancel="cancelselect"
            />
        </van-popup>
    </div>
</template>
<script>
import {fetchVerifyAuthForB} from '@/libsV2/havc.js'
import { Dialog} from 'vant';

export default {
    data(){
        return {
            selectExperience:'',//选择时间
            pickerKey:'content',        //选择器的key
            id:'',//报告id
            BselectTime:false,          //时间选择
            currentDate:'',             //选中的时间
            BselectInfo:false,          //选择其他信息、
            Breason:'',                 //lostReason,代表丢单原因。successReason表示成单原因,goOn表示都不需要
            columns:[],                 //picker需要的数组
            pickerType:'',              //点击选择的类型
            selectOptions:{             //展示的下拉内容
                type_chat:'',           //带看结果
                type_compare:'',        //对比系统
                type_fail:'',           //丢单原因
            },
            is_temp:'',
            userTypeObj:{},                    // 选择的用户类型
            options:{
                type_chat:'',           //带看结果
                type_compare:'',        //对比系统
                type_fail:'',           //丢单原因
                reason_chat:'',         //带看结果2
                reason_success:'',      //成功原因，
                takeLook:'',            //设计师带看
                num_chat:'',            //第几次带看
                feed_at:'',             //带看时间
                sign_name:'',           //签单手姓名
                account_source:'',      //信息渠道
                uname:'',               //客户名字
                sex:'',                 //性别
                is_store:'',            //前期是否去过门店
                sign_state:'',          //负责人是否在场
                phone:'',               //手机号码
                job:'',                 //职业
                age:'',                 //年龄
                community:'',           //安装小区
                prospect_state:'',      //专职人员是否在场
                prospect_name:'',       //其他在场人员
                keep_time:'',           //用户停留时间
            }
        }
    },
    watch:{
        Breason(newValue,oldValue) {
            //lostReason,代表丢单原因。successReason表示成单原因,goOn表示都不需要
            if (newValue == 'lostReason') {
                this.$set(this.options,'reason_success','')
            } else if (newValue == 'successReason'){
                this.$set(this.options,'type_fail','')
            } else {
                this.$set(this.options,'type_fail','')
                this.$set(this.options,'reason_success','')
            }
        }
    },
    created () {
        // 页面参数有 4个
        // 1. id 就是体验反馈id
        // 2. type 这个是用户类型。就是下面数组的id
        // 3. uname  这个就是用户名称
        // 4. is_temp 这个是用来判断用户是未预约核销还是预约核销的 1未预约核销 0已预约核销
        fetchVerifyAuthForB(() => {
            let id = this.$route.query.id
            let type = this.$route.query.user_type
            let typeList = [
                {name:'潜客',id:0},
                {name:'潜客(未录入)',id:4},
                {name:'设计师',id:1},
                {name:'设计师(未录入)',id:5},
                {name:'异业',id:2},
                {name:'其他',id:3},
            ]
            this.userTypeObj = typeList.find( item => item.id == type )

            // if (this.$route.query.is_temp == 1) {
            //     this.userTypeObj = {}
            // }
            this.is_temp = this.$route.query.is_temp
            this.id = id
            this.$store.dispatch('userTalkAppointV3/commonVuex/getReportfeed',{report_id:id}).then (() => {
                console.log(this.feedObj,'feedboj');
                let {
                    feed_at,sign_at,sign_name,sign_state,uname,sex,phone,age,job,community,prospect_state,prospect_name,num_chat,is_store,keep_time,type_chat,type_compare,reason_success,appoint_time,nickname
                } = this.feedObj
                this.options = {
                    feed_at,sign_at,nickname,sign_name,sign_state,uname,sex,phone,age,job,community,prospect_state,prospect_name,num_chat,is_store,keep_time,type_chat,type_compare,appoint_time,account_source:this.feedObj.source,reason_success
                }
                console.log(this.$route.query.uname,'this.$route.query.uanme')
                if (!this.options.uname) {
                    this.$set(this.options,'uname',this.$route.query.uname)
                }
            })
        })
    },
    methods :{
        // 点击选择信息渠道
        selectSource () {
            if (this.$route.query.user_type == 0) {
                return
            }
            this.$store.dispatch({type:'userTalkAppointV3/getSource'}).then ( () => {
                this.BselectInfo = true
                this.columns = this.SourceList
                this.pickerType = 'select_source'
                this.pickerKey = 'value'
            })
        },
        // 选择用户类型
        selectType () {
            // is_temp 这个是用来判断用户是未预约核销还是预约核销的 1未预约核销 0已预约核销
            console.log(this.is_temp,'this.is_temp')
            if (this.is_temp == 0) {
                return
            }
            this.BselectInfo = true
            this.pickerType = 'userType'
            this.columns = [
                { name: '潜客(未录入)', id:4 },
                { name: '设计师', id: 1 },
                { name: '设计师(未录入)', id:5},
                { name: '异业', id: 2 },
                { name: '其他', id: 3 },
            ]
            this.pickerKey = 'name'
        },
        // 点击选择体验时常
        showExperienceTime () {
            this.BselectInfo = true
            this.pickerType = 'experienceTime'
            this.columns = this.experienceTimeList
        },
        // 职业修改
        jobChange () {
            let reg = new RegExp("[\\u4E00-\\u9FFF]+$","g");
            if(!reg.test(this.options.job)&& this.options.job){
                this.$refs.jobInputRef.focus()
                Dialog({title:'用户职业必须是纯文字'})
            } else if (this.options.job.length > 15 &&this.options.job) {
                this.$refs.jobInputRef.focus()
                Dialog({title:'用户职业最多15个字'})
            }
        },
        // 停留时间修改
        keepTimeChange () {
            // 不等于 -1 说明存在小数点
            if (this.options.keep_time.indexOf('.') != -1) {
                this.$set(this.options,'keep_time',Number(this.options.keep_time).toFixed(1))
            }
            if (Number(this.options.keep_time) > 48) {
                this.$set(this.options,'keep_time',48)
            }
        },
        // 年龄修改
        ageChange () {
            if (Number(this.options.age) > 120) {
                this.$set(this.options,'age','120')
            } else if (this.options.age.indexOf('.') != -1) {
                this.$set(this.options,'age',Number(this.options.age).toFixed(0))
            }
        },
        // 手机号码拾取焦点触发的函数
        testPhone () {
            let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!myreg.test(this.options.phone)) {
                Dialog({title:"请填写正确的手机号码"});
                this.$refs.phoneInputRef.focus()
            }
        },
        // 点击取消
        cancelselect () {
            this.BselectInfo = false
            if (this.pickerType == 'reason') {
                this.options.type_fail = ''
                this.selectOptions.type_fail = ''
                this.Breason = ''
            }
        },
        // 点击提交
        submit () {
            let options = this.options
            let myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;

            if (!options.feed_at) {
                Dialog({title:'请选择带看时间'})
            } else if (!options.sign_name) {
                Dialog({title:'请填写签单手姓名'})
            } else if (!myreg.test(this.options.phone) && this.options.phone) {
                Dialog({title:"请填写正确的手机号码"});
            } else if (!options.account_source &&( this.$route.query.user_type != 2 && this.$route.query.user_type != 1 && this.$route.query.user_type != 5 )) {
                // 设计师，异业的时候不展示信息渠道，那就也不需要判断是否
                Dialog({title:'请填写信息渠道'})
            } else if (!options.uname) {
                Dialog({title:'请填写客户姓名'})
            } else if (options.num_chat == 0) {
                Dialog({title:'请选择带看属于第几次交流'})
            } else if (options.type_chat == 0 && this.showResult) {
                // 如果是潜客，而且没填带看结果
                Dialog({title:'请选择带看结果'})
            } else if (options.type_compare == 0  && this.showResult) {
                Dialog({title:"请选择对比系统"})
            } else if (options.type_fail == 0 && !options.reason_success && this.Breason != 'goOn') {
                Dialog({title:'请选择丢单原因或者成单原因'})
            } else {
                // 如果用户类型不是潜客，不需要选择带看结果，需要自己手写
                if (this.$route.query.user_type != 0 && this.$route.query.user_type != 4 ) {
                    this.$delete(this.options,'type_chat')
                }
                // Dialog({title:'success'})
                // console.log(this.userTypeObj,'this.userTypeObj.id')
                // return
                // is_temp 这个是用来判断用户是未预约核销还是预约核销的 1未预约核销 0已预约核销
                let userTypeObj
                if (this.is_temp == 1) {
                    userTypeObj = {
                        user_type:this.userTypeObj.id
                    }
                } else {
                    userTypeObj = {}
                }
                this.$store.dispatch('userTalkAppointV3/commonVuex/SendreportFeed',{...options,report_id:this.id,sign_keep:this.selectExperience,...userTypeObj})
                    .then(() => {
                        this.$toast('提交成功')
                        this.$router.go(-1)
                    })
            }
        },
        // silder选择
        silderClick (type,value) {
            this.$set(this.options,type,value)
        },
        // 选择性别
        sexClick () {
            this.BselectInfo = true
            this.columns = ['未知','男','女']
            this.pickerType = 'select_sex'
        },
        // 选择第几次交流
        selectNum (type) {
            if (type == 'people_num') {
                this.pickerType = 'people_num';
                this.columns = [1,2,3,4,5,6,7,8,9,10]
                this.BselectInfo = true
            } else {
                this.pickerType = 'select_num';
                this.columns = [1,2,3,4,5,6,7,8,9,10]
                this.BselectInfo = true
            }
        },
        // 点击出现picker
        selectfeedType (index) {
            if (index == 0) {
                this.pickerType = 'type_chat'  //带看结果
            } else if (index == 1) {
                this.pickerType = 'type_compare' //对比系统
            } else if (index == 2) {
                this.pickerType = 'reason' //丢单原因
            }
            if (index == 2 && this.Breason == 'successReason') {
                this.$toast('您已填写成单原因')
                return
            }
            let feed_type = this.feed_type
            this.columns = feed_type[index].items
            this.BselectInfo = true
            this.pickerKey = 'content'
        },
        // 确定选择下拉框
        selectInfo (select){
            if (this.pickerType == 'experienceTime') {
                this.selectExperience = select
            } else if (this.pickerType == 'userType') {
                this.userTypeObj = select
            }
            if (this.pickerType == 'people_num') {
                this.$set(this.options,'user_num',select)
                console.log(this.options.user_num,'user_num')
            }
            if (this.pickerType == 'select_source') {
                this.$set(this.options,'account_source',select.value)
            }
            if (this.pickerType == 'type_chat') {
                if (select.content.indexOf('丢单') != -1 ) {
                    this.Breason = 'lostReason'    //lostReason,代表丢单原因。successReason表示成单原因
                } else if (select.content.indexOf('成单') != -1  ){
                    this.Breason = 'successReason'
                } else {
                    this.Breason = 'goOn'
                }
                this.options.type_chat = select.id
                this.selectOptions.type_chat = select.content
            } else if (this.pickerType == 'type_compare') {
                this.options.type_compare = select.id
                this.selectOptions.type_compare = select.content
            } else if (this.pickerType == 'reason') {
                // if (select.content == '未选择') {
                //     this.selectOptions.type_fail = select.content
                //     this.Breason = ''
                //     this.BselectInfo = false
                //     return
                // }
                this.options.type_fail = select.id
                this.Breason = 'lostReason'
                this.selectOptions.type_fail = select.content
            } else if (this.pickerType == 'select_num') {
                this.options.num_chat = select
            } else if (this.pickerType == 'select_sex') {
                if (select == '男') {
                    console.log(111)
                    this.$set(this.options,'sex',1)
                } else if (select == '未知'){
                    this.$set(this.options,'sex',0)
                } else {
                    console.log(114457465)
                    this.$set(this.options,'sex',2)
                }
            }
            this.BselectInfo = false
        },
        // 选择时间
        selectTime (time) {
            let times = new Date(time)
            let year = times.getFullYear();
            let month = times.getMonth() + 1
            let day = times.getDate()
            month = (month > 10) ?month:('0' + month)
            day = (day > 10) ?day:('0' + day)
            times = year + '-' + month + '-' + day
            this.currentDate = times
            this.BselectTime = false
        }
    },
    computed:{
        // is_temp 这个是用来判断用户是未预约核销还是预约核销的 1未预约核销 0已预约核销
        // 展示结果
        showResult () {
            if (this.is_temp == 0 ) {
                return  this.$route.query.user_type == 0 ||  this.$route.query.user_type == 4
            } else {
                return this.userTypeObj.id == 0 ||  this.userTypeObj.id == 4
            }
        },
        // 展示时间
        appointTime (time) {
            console.log(time,'time')
            return time => {
                if (!time) {
                    return ''
                }
                let timelist = JSON.parse(time)
                let timeObj = timelist[0]
                return `${timeObj.mark_start.substring(0,10)} ${timeObj.mark_start.substring(11,16)}~${timeObj.mark_end.substring(11,16)}`
            }
        },
        experienceTimeList () {
            let num = 12
            let list = []
            for ( let i = 0.5;i<= num ;i += 0.5) {
                list.push(i)
            }
            return list
        },
        feedObj () {
            return this.$store.state.userTalkAppointV3.commonVuex.feedObj
        },
        SourceList () {
            return this.$store.state.userTalkAppointV3.SourceList
        },
        feed_type() {
            let feed_type = this.$store.state.userTalkAppointV3.commonVuex.feed_type
            console.log(this.Breason,'reason');
            if (this.Breason != 'lostReason') {
                feed_type = feed_type.filter(i => {
                    return i.name != '丢单原因'
                })
            }
            return feed_type
        },
        // 下拉之前展示的数据
        showfeedType (index) {
            return function (index) {
                if (index == 0) {
                    return this.selectOptions.type_chat || '请选择'
                } else if (index == 1) {
                    return this.selectOptions.type_compare || '请选择'
                } else if (index == 2) {
                    return this.selectOptions.type_fail || '请选择'
                }
            }
        }
    }
}
</script>
<style lang='scss' scoped>
.mustFill {
    color: red;
    position:absolute;
    left: 10px;
    top: 20px;
}
.flc{
    display:flex;
    justify-content:center;
    align-items:center;
}
.positionc{
    left:50%;
    transform:translate(-50%);
}
.container {
    width:100%;
    padding: 28px 24px 0 24px;
    background: #F0F4F1;
    .content{
        background-color: #ffffff;
        width: 100%;
        padding: 32px 24px 0 26px;
        border-radius: 12px;
        .title_box {
            display:flex;
            align-items:center;
            .left {
                width: 6px;
                height: 32px;
                background: #318544;
            }
            .title {
                margin-left: 12px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #318544;
            }
        }
        .input_box {
            margin-top: 32px;
            .info {
                margin-bottom: 24px;
                width: 100%;
                box-sizing: border-box;
                border-radius: 12px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                //color: #A2A2A2;
                display: flex;
                background: #F7F7F7;
                .tip {
                    font-size: 28px;
                    font-weight: 400;
                    color: #A2A2A2;
                    white-space: nowrap;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    padding-left: 28px ;
                    position:relative;
                }
                .input2{
                    display: flex;
                    align-items: center;
                    min-height: 80px;
                    padding-left: 20px;
                    flex: 1;
                }
                input {
                    width: 100%;
                    border-radius: 12px;
                    background: #F7F7F7;
                    display: flex;
                    align-items: center;
                    min-height: 80px;
                }
                .inputbox {
                    flex:1;
                    z-index:8;
                    min-height: 40px;
                    padding: 20px;
                    background: #F7F7F7;
                    position: relative;
                    color: transparent;
                    textarea{
                        position: absolute;
                        width: 101%;
                        height: 100%;
                        padding: 20px;
                        left: 0;
                        top: 0;
                        color:#000;
                        resize: none;
                        background-color: transparent;
                        z-index: 10;
                    }
                }
                input::-webkit-input-placeholder {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #A2A2A2;
                }
            }
            .href {
                display: grid;
                grid-template-columns: 1fr 1fr;
                column-gap: 22px;
                .item{
                    margin-bottom: 24px;
                    width: 316px;
                    box-sizing: border-box;
                    border-radius: 12px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    display:flex;
                    background: #F7F7F7;
                    input{
                        flex: 1;
                        min-height:80px;

                        width: 100%;
                        border-radius: 12px;
                        background: #F7F7F7;
                    }
                    &:nth-child(2n) {
                        margin-right: 0;
                    }
                    .tip {
                        white-space: nowrap;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        padding-left: 20px;
                        position:relative;

                        color: #A2A2A2;
                    }
                    .input4 {
                        padding: 20px;
                        min-height:80px;
                    }
                    div:nth-child(2) {
                        flex: 1;
                        white-space: nowrap;
                        input {
                            width: 100%;
                            background: #F7F7F7;
                        }
                        input::-webkit-input-placeholder {
                            font-size: 28px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            //color: #A2A2A2;
                        }
                    }
                }
            }
        }
        .line {
            height: 2px;
            width: 100%;
        }
        .silder_group {
            padding-top: 26px;
            .silder_item {
                margin-bottom: 22px;
                padding-left: 2px;
                padding-right: 4px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .tip {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #444444;
                    position:relative;

                }
                .silder {
                    width: 178px;
                    height: 52px;
                    border-radius: 8px;
                    border: 2px solid #318544;
                    display:flex;
                    div{
                        flex:1;
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #A2A2A2;
                    }
                    .silder_active {
                        background-color: #318544;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .select_group {
            padding-top: 2px;
            .select_item {
                margin-bottom: 22px;
                padding-left: 2px;
                padding-right: 4px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .tip {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    position:relative;
                    color: #444444;
                }
                .select {
                    border-radius: 8px;
                    border: 2px solid #DBDBDB;
                    padding: 8px 14px 10px 30px;
                    display: flex;
                    align-items: center;
                    .img_box{
                        z-index: 9;
                        margin-left: 16px;
                        width: 32px;
                        height: 32px;
                        img{
                            width: 32px;
                            height: 32px;
                        }
                    }
                }
            }
        }
        .input_group {
            margin-top: 34px;
            .textarea_box {
                padding-bottom: 28px;
                .tip {
                    margin-bottom: 20px;
                    font-size: 28px;
                }
                .textarea {
                    z-index: 8;
                    font-size: 28px;
                    padding: 20px;
                    padding-right: 28px;
                    box-sizing: border-box;
                    width: 100%;
                    background-color: #F7F7F7;
                    color: transparent;
                    border-radius: 12px;
                    position: relative;
                    div {
                        z-index: 7;
                    }
                    input,textarea {
                        z-index: 9;
                        position: absolute;
                        width: 100%;
                        height:100%;
                        background-color:transparent;
                        border-radius: 12px;
                        color: #A2A2A2;
                        left: 0;
                        padding: 20px;
                        font-size: 28px;
                        top: 0;
                        resize: none;
                    }
                }
            }
            .input_item {
                padding-bottom: 28px;
                .tip {
                    margin-bottom: 20px;
                }
                .input {
                    min-height:68px;
                    width: 100%;
                    input {
                        background: #F7F7F7;
                        border-radius: 12px;
                        padding: 21.5px;
                        font-size: 28px;
                        width: 100%;
                    }
                    .likeInputBox {
                        background: #F7F7F7;
                        border-radius: 12px;
                        padding: 20px;
                        width: 100%;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #A2A2A2;
                    }
                    input::-webkit-input-placeholder {
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #A2A2A2;
                    }

                }
            }
        }
    }
    .btn {
        margin-top: 32px;
        margin-bottom:52px;
        width: 100%;
        padding: 28px 0;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
        border-radius: 12px;
    }
}
.flc2{
    display: flex;
    align-items: center;
}
.colorGray {
    color:#A2A2A2;
}
</style>
